import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import { FaBook, FaFacebookF, FaInstagram, FaPinterest, FaTwitter, FaYoutube, FaCheck, FaSketch, FaOpencart } from "react-icons/fa";
import { BsSendCheck, BsFill1CircleFill, BsFill2CircleFill, BsFill3CircleFill, BsFill4CircleFill, BsFill5CircleFill, BsCheckLg, BsFillPatchCheckFill, BsClipboardCheck } from "react-icons/bs";

function HowToRead() {

    return (

        <Container>

            <br/>

            <h3><strong><FaBook/> วิธีอ่านหนังสือ</strong></h3>
       
            <h3 className="pb-3 border-bottom"></h3>
            <br/>
            <p style={{marginTop: 5}}>(1) ดาวน์โหลดแอพพลิเคชั่น EduLaw ในระบบ ios ทาง App Store
            <br/>(2) เปิดแอพพลิเคชั่น ในหน้า “บัญชี” กดสร้างบัญชีเพื่อสมัครสมาชิก
            <br/>(3) ซื้อหนังสือผ่านเว็บไซต์เพื่อรับ Coupon Code หนังสือ
            <br/>(4) ใช้ Coupon Code ในเว็บไซต์ที่ได้รับจากร้านค้า เพื่ออ่านหนังสือ Ebook ได้ทั้งในระบบออนไลน์และออฟไลน์
            </p>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
           
            

        </Container>

    );

}

export default HowToRead;